// @flow

import { SET_ACTIVE_LANGUAGE } from './constants';
import type { State, SetActiveLanguage } from './types';

const initialState = 'nl';

export default (state: State = initialState, action: SetActiveLanguage): State => {
  switch (action.type) {
    case SET_ACTIVE_LANGUAGE:
      return action.payload.language;
    default:
      return state;
  }
};
